var rich_content_viewer_default = {
  "fontElementMap": "FXnNe",
  "wrapper": "Z-A1Y",
  "pluginContainerMobile": "lAtml",
  "viewer": "Nj8Eq",
  "android": "_4KAG8",
  "rootedTraversedContent": "t7lVb",
  "atomic": "S7p6P",
  "toolbar": "bGsvu",
  "block": "Wtudm"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
